// 코드값 탭 저장 실패 문구 — 여러 묶음을 차례로 보내므로 어느 묶음·어느 줄인지 붙인다(화면에서 새 줄은 코드 대신 「새 항목 n」 으로 보인다).

import type { CodeEntry } from "./codes";

// 줄의 이름 — 표기가 있으면 표기, 없으면 새 줄은 「새 항목 n」(그 묶음의 새 줄 중 몇 번째), 저장된 줄은 코드.
export const codeRowName = (list: CodeEntry[], index: number, fresh: string[]): string => {
  const row = list[index];
  if (!row) return `${index + 1}번째 줄`;
  if (row.label.trim() !== "") return row.label.trim();
  if (!fresh.includes(row.code)) return row.code;
  const order = list.slice(0, index + 1).filter((item) => fresh.includes(item.code)).length;
  return `새 항목 ${order}`;
};

export const codeSaveFailure = (
  group: string,
  list: CodeEntry[],
  fresh: string[],
  result: { message: string; row?: number }
): string =>
  result.row === undefined
    ? `${group} — ${result.message}`
    : `${group} · ${codeRowName(list, result.row, fresh)} — ${result.message}`;
